module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('pl-input', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Search by name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filters.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.user_search),
      callback: function($$v) {
        _vm.user_search = $$v
      },
      expression: "user_search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('pl-input', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Search by email"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filters.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.email_search),
      callback: function($$v) {
        _vm.email_search = $$v
      },
      expression: "email_search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subjects col-xs-2"
  }, [_c('multiselect', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "options": _vm.subjects,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "Subjects",
      "label": "name",
      "track-by": "id",
      "limit": 1,
      "preselect-first": true
    },
    on: {
      "input": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selected_subjects.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n            " + _vm._s(_vm.selected_subjects.length) + " options selected\n          ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selected_subjects),
      callback: function($$v) {
        _vm.selected_subjects = $$v
      },
      expression: "selected_subjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.hasAdminAdminPermission ? 'col-xs-2' : 'col-xs-3']
  }, [_c('pl-select', {
    staticClass: "dialog-role-select",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "options": _vm.teachers,
      "selected": _vm.selected_userType,
      "disabled": _vm.show_trial_teachers,
      "arrow": true,
      "placeholder": "All users"
    },
    on: {
      "change": function($event) {
        return _vm.filterUsersByType($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.hasAdminAdminPermission ? 'col-xs-2' : 'col-xs-3']
  }, [_c('multiselect', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "options": _vm.schoolSites,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "All Sites",
      "label": "name",
      "track-by": "id",
      "limit": 1,
      "preselect-first": true
    },
    on: {
      "input": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selected_school_sites.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n            " + _vm._s(_vm.selected_school_sites.length) + " school sites selected\n          ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selected_school_sites),
      callback: function($$v) {
        _vm.selected_school_sites = $$v
      },
      expression: "selected_school_sites"
    }
  })], 1), _vm._v(" "), (_vm.hasAdminAdminPermission) ? _c('div', {
    staticClass: "col-xs-2 end-xs"
  }, [_c('toggle-button', {
    attrs: {
      "value": _vm.show_trial_teachers,
      "labels": true,
      "color": "#72ccd7"
    },
    on: {
      "change": _vm.handleTrialTeachers
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml2"
  }, [_vm._v(" Trial Teachers ")])], 1) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.show_trial_teachers) ? _c('div', {
    staticClass: "trial-div mv3"
  }, [_vm._v("\n    This is a list of teachers whose accounts are not upgraded, but whose\n    email addresses also match the approved email suffixes for your school /\n    district. Press upgrade to automatically upgrade these teacher accounts so\n    they can have full access to Parlay. You may see names here that are part\n    of your district, but not part of your school.\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "permissions-work-style"
  }, [_c('a', {
    attrs: {
      "href": "https://support.parlayideas.com/en/articles/5376837-admin-portal-permissions",
      "target": "_blank"
    }
  }, [_vm._v("How do permissions work?\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-8482aa86!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalUsers/adminPortalUsersFiltersBar.vue
// module id = 2025
// module chunks = 61